import * as RadixAccordion from '@radix-ui/react-accordion';
import classNames from 'classnames';
import { CaretDown } from 'phosphor-react';
import type { PropsWithChildren } from 'react';

type AccordionProps = {
  className?: string;
  openItems?: string[];
};

export const Accordion = ({ children, openItems, className }: PropsWithChildren<AccordionProps>) => (
  <RadixAccordion.Root
    type="multiple"
    className={classNames('tds-accordion', className)}
    defaultValue={openItems}
  >
    {children}
  </RadixAccordion.Root>
);

type AccordionItemProps = {
  header: string;
  disabled?: boolean;
  className?: string;
};

export const AccordionItem = ({ header, children, disabled, className }: PropsWithChildren<AccordionItemProps>) => {
  return (
    <RadixAccordion.Item className="tds-accordion-item" value={header} disabled={disabled}>
      <RadixAccordion.Trigger className="flex flex-row w-full tds-accordion-header">
        <div className="items-start flex-1">{header}</div>
        {/* prevents scrollbars when animating the chevron */}
        <div className="overflow-hidden">
          <CaretDown className="tds-accordion-chevron" />
        </div>
      </RadixAccordion.Trigger>
      <RadixAccordion.Content className={classNames('tds-accordion-content', className)}>{children}</RadixAccordion.Content>
    </RadixAccordion.Item>
  );
};
